import React from 'react'
import Layout from '../components/layout/Layout'
import AdminUsersTable from '../elements/tables/users/AdminUsersTable'

export default function ActiveUsers() {
  return (
    <div>
      <Layout>
        <AdminUsersTable />
      </Layout>
    </div>
  )
}
